import type { createClient } from '@/lib/supabase/client';

type SupabaseBrowserClient = ReturnType<typeof createClient>;

/** Install the current JWT before a notification channel subscribes. */
export async function prepareNotificationRealtimeAuth(
  supabase: SupabaseBrowserClient,
): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token && typeof supabase.realtime?.setAuth === 'function') {
    await supabase.realtime.setAuth(session.access_token);
  }
}

/** Fast local retry without inheriting failures from unrelated Realtime channels. */
export function notificationRealtimeRetryDelay(failureCount: number): number {
  const boundedFailureCount = Math.max(1, Math.floor(failureCount));
  return Math.min(5_000 * (2 ** (boundedFailureCount - 1)), 60_000);
}
